import http from '@/plugins/axios';

export async function get_promotions(payload) {
    const response = await http.get(`promotion`, { params: payload });
    return response.data;
}

